export default "/images/vendor/flag-icon-css/flags/1x1/cf.svg?eb50c5ecfa556ddba5a7a7e6cdd0c75e";